



import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({})
export default class MdcListItemText extends Vue{
  @Prop({default:'div'})
  tag!:string
}
